import { useEffect, useState } from "react";
import PopupContent from "../popupContent";
import "./ProductTreeSelector.css";
import "./ProductBreadCrumb.css";
import ChildProductGroup from "./ChildProductGroup";
import { useTranslation } from "react-i18next";

interface Props {
    productGroup: any;
    selectedGroups: any[];
    isChecked?: boolean;
    onChange: any;
}

const MainProductGroup = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'ProductGroupsTree' })
    const [selectedGroups, setSelectedGroups] = useState<any[]>([]);
    useEffect(() => {
        setSelectedGroups(props.selectedGroups);
    }, [props.selectedGroups.length]);

    let itemClassName = true
        ? `treeview-item-selectable`
        : `treeview-item`;

    if (props.productGroup.isRootForDecorative) {
        itemClassName += " rootDecorative";
    }

    if (props.productGroup.isRootForIndustry) {
        itemClassName += " rootIndustry";
    }

    const isChecked = selectedGroups.find(g => { return g === props.productGroup.id }) ? true : false;

    const handleChildGroupChange = (groupId, checked) => {
        props.onChange(groupId, checked);
    }

    const handleChange = (e) => {
        props.onChange(props.productGroup.id, e.currentTarget.checked);
    }
    const label = t(`${props.productGroup.id}.name`) || props.productGroup.name;

    return (
        <>
            <ul className={`treeview-animated-list mb-3`}>
                <li className="">
                    <a className="closed">
                        <span className="">
                            <input type="checkbox" checked={isChecked} onClick={handleChange}></input>
                            &nbsp;
                            {props.productGroup.isRootForDecorative && (
                                <i className="fas fa-palette ic-w mx-1"></i>
                            )}

                            {props.productGroup.isRootForIndustry && (
                                <i className="far fas fa-industry ic-w mx-1"></i>
                            )}

                            <span
                                className={itemClassName}
                            >
                                {label}
                            </span>
                            {props.productGroup.childGroups &&
                                props.productGroup.childGroups.length > 0 &&
                                props.productGroup.childGroups.map((childGroup: any) => {
                                    return <ChildProductGroup
                                        productGroup={childGroup}
                                        selectedGroups={selectedGroups}
                                        onChange={handleChildGroupChange}
                                    />
                                })}
                        </span>
                    </a>
                </li>
            </ul>
        </>
    );
};

export default MainProductGroup;
